import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';

export const institutionGuard: CanActivateFn = (
  route, 
  state,
  router: Router = inject(Router),
) => {
  if (localStorage.getItem(environment.accessTokenName) && localStorage.getItem(environment.institutionKeyName)) {
    return true;
  }

  if (localStorage.getItem(environment.accessTokenName)) {
    router.navigate(['/institution-select']);
    return false;
  }

  router.navigate(['/login']);
  return false;
};
